import {Component} from '@angular/core';

@Component({
  selector: 'cm-pulsing-indicator',
  template: `<span class="notification-circle"></span>`,
  styles: [`
	.notification-circle {
		position: absolute;
		top: 50%;
		right: 5px;
		width: 6px;
		height: 6px;
		background: $primary-color;
		border-radius: 50%;
		margin-top: -3px;
		animation: blink 1.5s ease-in-out infinite;
	}
  `]
})
export class PulsingIndicatorComponent {

}
